
$views.foldersettings = {
	
	display : function() {
		
		$models.foldertypes.getList({}, function($types) {
			jQuery.each($types.folder_types, function($key, $type) {
				$views.foldersettings.renderFolderType('1', $type);
			});
			$views.foldersettings.disableFormIfNotAdmin();
		});
		
		$models.folderstatuses.getList({}, function($statuses) {
			jQuery.each($statuses.folder_statuses, function($key, $status) {
				$views.foldersettings.renderFolderStatus('1', $status);
			});
			$views.foldersettings.disableFormIfNotAdmin();
		});
		
	},
	
	disableFormIfNotAdmin : function() {
		
		if (!$models.login.hasAdminPrivileges()) {
			jQuery('input, select, textarea').attr('disabled', 'disabled');
			jQuery('.add_a_type, .add_a_status, .delete-button').hide();
			jQuery('.add_a_type, .add_a_status, .edit-button').hide();
		}
		
	},
	
	renderFolderType : function($class, $type) {
		
		var $ajaxHtmlForDiv =  '<li class="row'+$class+'" id="foldertype_'+$type.id+'">';
		$ajaxHtmlForDiv += '<span class="foldertypes_type_name">'+$type.name+'</span>';
		$ajaxHtmlForDiv += '<span class="foldertypes_type_name_edit" style="display:none"></span>';
		$ajaxHtmlForDiv += '<span class="foldertypes_type_id" style="display:none">'+$type.id+'</span>';
		$ajaxHtmlForDiv += '<a href="#" rel="tipsy" title="Delete Folder Type" class="delete-button" onclick="$controllers.foldersettings.deleteFolderType('+$type.id+'); return false"></a>';
		$ajaxHtmlForDiv += '<a href="#" rel="tipsy" title="Edit Folder Type" class="edit-button" onclick="$views.foldersettings.editFolderType('+$type.id+'); return false"></a>';
		$ajaxHtmlForDiv += '</li>';
		
		if (jQuery('#folder_types #foldertype_'+$type.id).size() <= 0) {
			jQuery('#folder_types').append($ajaxHtmlForDiv);
		}
		
		return $class;
		
	},
	
	editFolderType : function($type_id) {
		$controllers.foldersettings.cancelEditFolderType();
		var $type_name = jQuery('#foldertype_'+$type_id+' .foldertypes_type_name').html();
		jQuery('#foldertype_'+$type_id+' .edit-button').hide();
		jQuery('#foldertype_'+$type_id+' .foldertypes_type_name_edit').html('<input type="text" class="text" name="folder_type_edit_name" id="folder_type_edit_name" value="'+$type_name+'" maxlength="250" /><input type="button" value="Save" class="edit_folder_type_button" onclick="$controllers.foldersettings.editFolderType('+$type_id+'); return false" /><a class="cancel" href="#" onclick="$controllers.foldersettings.cancelEditFolderType(); return false">Cancel</a>');
		jQuery('#foldertype_'+$type_id+' .foldertypes_type_name').hide();
		jQuery('#foldertype_'+$type_id+' .foldertypes_type_name_edit').show();
		jQuery('#foldertype_'+$type_id+' #folder_type_edit_name').focus();
	},
	
	renderFolderStatus : function($class, $status) {
		
		var $ajaxHtmlForDiv =  '<li class="row'+$class+'" id="folderstatus_'+$status.id+'">';
		$ajaxHtmlForDiv += '<span class="folderstatuses_status_name">'+$status.name+'</span>';
		$ajaxHtmlForDiv += '<span class="folderstatuses_status_name_edit" style="display:none"></span>';
		$ajaxHtmlForDiv += '<span class="folderstatuses_status_id" style="display:none">'+$status.id+'</span>';
		$ajaxHtmlForDiv += '<a href="#" rel="tipsy" title="Delete Folder Status" class="delete-button" onclick="$controllers.foldersettings.deleteFolderStatus('+$status.id+'); return false"></a>';
		$ajaxHtmlForDiv += '<a href="#" rel="tipsy" title="Edit Folder Status" class="edit-button" onclick="$views.foldersettings.editStatusType('+$status.id+'); return false"></a>';
		$ajaxHtmlForDiv += '</li>';
		
		if (jQuery('#folder_statuses #folderstatus_'+$status.id).size() <= 0) {
			jQuery('#folder_statuses ').append($ajaxHtmlForDiv);
		}
		
		return $class;
		
	},
	
	editStatusType : function($status_id) {
		$controllers.foldersettings.cancelEditFolderStatus();
		var $status_name = jQuery('#folderstatus_'+$status_id+' .folderstatuses_status_name').html();
		jQuery('#folderstatus_'+$status_id+' .edit-button').hide();
		jQuery('#folderstatus_'+$status_id+' .folderstatuses_status_name_edit').html('<input type="text" class="text" name="folder_status_edit_name" id="folder_status_edit_name" value="'+$status_name+'" maxlength="250" /><input type="button" value="Save" class="edit_folder_type_button" onclick="$controllers.foldersettings.editFolderStatus('+$status_id+'); return false" /><a class="cancel" href="#" onclick="$controllers.foldersettings.cancelEditFolderStatus(); return false">Cancel</a>');
		jQuery('#folderstatus_'+$status_id+' .folderstatuses_status_name').hide();
		jQuery('#folderstatus_'+$status_id+' .folderstatuses_status_name_edit').show();
		jQuery('#folderstatus_'+$status_id+' #folder_status_edit_name').focus();
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/desktop.foldersettings.js